export default {
  path: "/main/system/department",
  name: "Department",
  component: () => import("@/views/main/System/department.vue"),
  children: []
};
